import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const SBannerWrapper = styled.div`
  margin-left: 10%;
  margin-right: 10%;
  display: flex;
  align-items: center;
  position: relative;
`;

const BalanceText = styled.p`
  font-size: 22px;
  color: #fafafa;
  opacity: 0.7;
  // font-family: 'NexaDemo-Light';
  margin: 2em 0;
  text-align: center;
  a {
    text-decoration: underline;
  }

  @media (max-width: 550px) {
    font-size: 18px;
  }
`;

const Description = () => {
  const { t } = useTranslation();

  return (
    <SBannerWrapper>
      <BalanceText>
        {t("OTCTitle")}
        <br />
        <br />
        {t("OTCDesc1")}
        <br />
        <br />
        {t("OTCDesc2")}
        <br />
        <br />
        {t("OTCDesc3")}
        <br />
        <br />
        {`${t("SeeOTC")} `}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://arbiscan.io/address/0x1f09f38795280e68091ac90de91083228ba8b1d6#code"
        >
          {t("EtherscanHere")}
        </a>{" "}
        {t("ToReadCode")}
      </BalanceText>
    </SBannerWrapper>
  );
};

export default Description;
